<iframe 
    src="/assets/peach.js" 
    *ngIf="checkoutId" 
    id="cnpIframe" 
    name="cnpIframe" 
    frameBorder="0" 
    (load)="onLoad()" 
    style="width:100%;height:500px">
</iframe>